import {
  COLORES_DE_ESTADO,
  etiquetaDeEstado,
} from '@/features/pricer-datec/components/estado-cotizacion';

/** El estado de una cotización en español, con los mismos colores que la lista y la ficha del Pricer. */
export function ChipDeEstado({ status }: { status: string }) {
  const colores = COLORES_DE_ESTADO[status] ?? COLORES_DE_ESTADO.DRAFT;
  return (
    <span
      data-testid="chip-de-estado"
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap"
      style={{ background: colores.bg, color: colores.color }}
    >
      {etiquetaDeEstado(status, false).texto}
    </span>
  );
}
